(function () {
  function copyCoupon(button) {
    const code = button.getAttribute("data-rebx-coupon-copy");
    if (!code) return;

    const root = button.closest(".rebx-bargain-coupon");
    const toast = root?.querySelector(".rebx-bargain-coupon__toast");

    const onSuccess = () => {
      if (toast) {
        toast.classList.remove("visually-hidden");
        window.setTimeout(() => toast.classList.add("visually-hidden"), 2000);
      }
      button.classList.add("rebx-bargain-coupon__copy--copied");
      window.setTimeout(
        () => button.classList.remove("rebx-bargain-coupon__copy--copied"),
        2000
      );
    };

    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(code).then(onSuccess).catch(() => {});
      return;
    }

    const input = document.createElement("textarea");
    input.value = code;
    input.setAttribute("readonly", "");
    input.style.position = "absolute";
    input.style.left = "-9999px";
    document.body.appendChild(input);
    input.select();
    try {
      document.execCommand("copy");
      onSuccess();
    } catch (e) {
      /* ignore */
    }
    document.body.removeChild(input);
  }

  document.addEventListener("click", (event) => {
    const button = event.target.closest("[data-rebx-coupon-copy]");
    if (!button) return;
    event.preventDefault();
    copyCoupon(button);
  });
})();
